export default __webpack_public_path__ + "static/media/leveltwo_segment.e1c71483.svg";